import "./footer.css";

import React from "react";
import { Link } from "react-router-dom";
import { KeyboardArrowUp as UpIcon } from "@mui/icons-material";

import { PAGE_ROUTES } from "../../utils/stateTypes";
import { prefersReducedMotion } from "../../utils/generalUtils";

const Footer = () => {
  const backToTop = () => {
    window.scrollTo({ top: 0, behavior: prefersReducedMotion() ? "auto" : "smooth" });
  };

  return (
    <footer className={"footer"}>
      <div className={"container"}>
        <button
          type={"button"}
          className={"footer-top"}
          onClick={backToTop}
        >
          <UpIcon />
          <span>BACK TO TOP</span>
        </button>
        <p className={"footer-privacy"}>
          <Link to={PAGE_ROUTES.PRIVACY}>Privacy Policy</Link>
        </p>
        <p className={"footer-copyright"}>
          ©2020 by PM Skillshouse Foundation
          <br />
          Created by{" "}
          <a
            href={"https://tap-x.com/"}
            target={"_blank"}
            rel={"noopener noreferrer"}
          >
            TapX
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
